var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgStationaryBox = function SvgStationaryBox(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 700 700",
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.69.41h700v700H.69z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M565.06 700.41H136.31c-2.42 0-4.38-1.96-4.38-4.38V4.79c0-2.42 1.96-4.38 4.38-4.38h428.75c2.42 0 4.38 1.96 4.38 4.38v691.25c0 2.41-1.96 4.37-4.38 4.37m-385-43.75h341.25c2.42 0 4.38-1.96 4.38-4.38V48.54c0-2.42-1.96-4.38-4.38-4.38H180.06c-2.42 0-4.38 1.96-4.38 4.38v603.75a4.39 4.39 0 0 0 4.38 4.37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M455.69 175.41h-210c-2.42 0-4.38-1.96-4.38-4.38v-35c0-2.42 1.96-4.38 4.38-4.38h210c2.42 0 4.38 1.96 4.38 4.38v35a4.385 4.385 0 0 1-4.38 4.38"
  })));
};
export default SvgStationaryBox;